export const LOGIN_URL = "/login";
export const PATIENT_SIGNUP = "/patient-signup";
export const PHARMCY_SIGNUP = "/pharmacy-signup";
export const PHYSICIAN_SIGNUP = "/physician-signup";
export const SPECIALIZATIONS = "/specializations";
export const OPERATIONS = "/physician/operation-hours";
export const PATIENTMEDICALREPORT = "/patient/medical-reports/upload";
export const FORGOT_PASSWORD = "/forgot-password";
export const CONTACT_US = "/inquiry-submit";
export const SITE_SETTINTG = "/site-setting";
export const FAQS = "/faqs";
export const TESTIMONIALS = "/testimonials";
export const OTP_API = "/verify-otp";
export const RESET_PASSWORD = "/reset-password";
export const CONTENT = "/content";
export const GENERATE_TOKEN = "/generate-agora-token";
export const TRIGGER_CALL = "/trigger-video-call";
export const ENDCALL = "/end-video-call";
export const TERMS_CONDITIONS = "/pages/terms-conditions";
export const PRIVACY_POLICY = "/pages/privacy-policy";
export const SIGNUPCOUNTRY = "/country";
export const SIGNUPCITY = "/country/cities";
export const SIGNUPSTATE = "/country/states";

// Patient Profile End Points
export const EDIT_PROFILE_URL = "/patient/profile-update";
export const GET_PROFILE = "/patient";
export const CHANGE_PASSWORD_URL = "/change-password";
export const CHECK_AVAILIABILTY = "/patient/check-availability";
export const SYMPTOMS = "/symptoms";
export const PATIENT_APPOINTMNETS = "/patient/appointments";
export const PATIENT_BOOK_APPOINTMNETS = "/patient/book-appointment";
export const PATIENT_BOOK_APPOINTMNETS_DETAILS = "/patient/appointments/detail";
export const PATIENT_ORDERS = "/patient/orders";
export const PATIENT_ORDERS_DETAIL = "/patient/orders";
export const UPDATE_PROFILE_IMAGE = "/update-profile-image";
export const GET_PATIENT_MEDICAL_REPORTS = "/patient/medical-reports";
export const DELETE_MEDICAL_REPORT = "/patient/medical-reports/delete";
export const PATIENT_VIEW_NOTE = "/patient/appointments/view-note";
export const PATIENT_CHAT = "/patient/chat";
export const PATIENT_SEND_MESSAGE = "/patient/chat/send-message";
export const PATIENT_VIEW_PRESCRIPTION =
	"/patient/appointments/view-prescription";
export const PATIENT_NEARSET_API = "/patient/appointments/get-nearest-pharmacy";
export const PATIENT_PLACE_ORDER = "/patient/appointments/place-order";

// ===================

// Physician Profile End Points
export const PHYSICIAN_EDIT_PROFILE_URL = "/physician/profile-update";
export const PHYSICIAN_SPECIALIZATION = "/specializations";
export const PHYSICIAN_APPOINTMNETS = "/physician/appointments";
export const PHYSICIAN_BOOK_APPOINTMNETS_DETAILS =
	"/physician/appointments/detail";
export const PHYSICIAN_BOOK_APPOINTMNETS_CLOSE =
	"/physician/appointments/close";
export const PHYSICIAN_WRITE_NOTES = "/physician/write-note";
export const PHYSICIAN_CHAT = "/physician/chat";
export const PHYSICIAN_SEND_MESSAGE = "/physician/chat/send-message";
export const PHYSICIAN_WRITE_PERSCRIPTION = "/physician/write-prescription";
export const PHYSICIAN_VIEW_NOTE = "/physician/appointments/view-note";
export const PHYSICIAN_VIEW_PRESCRIPTION =
	"/physician/appointments/view-prescription";
// =========================

// Pharmcy Profile End Points
export const PHARMACY_EDIT_PROFILE_URL = "/pharmacy/profile-update";
export const PHARMACY_ORDERS_ALL = "/pharmacy/orders";
export const PHARMACY_UPDATE_STATUS = "/pharmacy/orders/update-status";
// ==================
